// extracted by mini-css-extract-plugin
export default {"form":"style_form__x0ygH","errorText":"style_errorText__7gPov","submit":"style_submit__rm3LJ","inputLabel":"style_inputLabel__r3uNB"};